var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visitorIdentificationTimestamp)?_c('meta',{attrs:{"name":"VIcurrentDateTime","content":_vm.visitorIdentificationTimestamp}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }